/** 로그인 페이지 */
export const LOGIN_PAGE = 'DLLG-01-V101'

/** 메인 페이지(배송대기) */
export const MAIN_PAGE = 'DLDS-01-V101'
